<template lang="pug">
.new-method
  shForm(title="Nuevo Método de Pago")
</template>

<script>
import shForm from '@/components/pages/method/Form'

export default {
  name: 'NewMethod',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-method
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/method/New.vue